export default __webpack_public_path__ + "static/media/greenmagic.153ad8ce.png";